import { IgAlert } from "@intelligems/ig-theme";
import { postTestMetricsLink } from "@src/utils/linkSheet";
import { openNewTab } from "@src/utils/openNewTab";

const MESSAGE =
  "Post-test metrics track additional orders from customers who converted during the test, even after it's paused or ended, to measure long-term revenue and profit impact. Data continues to update for up to 1 year after test start.";

export const PostTestPageAlert = () => {
  return (
    <IgAlert
      alertKey="PostTestAnalyticsAlert"
      message={MESSAGE}
      severity="info"
      secondaryButton={{
        cta: "Learn more",
        onClick: () =>
          openNewTab(postTestMetricsLink, {
            mixpanelTracker: "Post-test metrics",
          }),
      }}
    />
  );
};
